import React, { useEffect, useState } from 'react';
import { Label } from 'reactstrap';
import ToggleSwitch from '../../components/ToggleSwitch';
import ClaimSearchFilter from '../../filters/ClaimSearchFilter';
import KTable from '../../components/KTable';
import classNames from 'classnames';
import ClaimSearchModal from '../modals/ClaimSearchModal';
import CenterSpinner from '../../components/CenterSpinner';
import { ClaimSearchDataType, ClaimSearchFilterType } from '../../utils/Types';
import { ClaimSearchColumnHeader, getClaimsRequest } from './ClaimSearchHelper';
import {
  ClaimsDataList,
  claimSearchSelector,
} from '../../features/claimSearchSlice';
import { toast } from 'react-toastify';
import { useAppDispatch, useAppSelector } from '../../store/redux-hooks';
import KPagination from '../../components/KPagination';

const ClaimSearchPage: React.FunctionComponent = () => {
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
  const [initModal, setInitModal] = useState<boolean>(false);
  const [pageSize, setPageSize] = useState<number>(20);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [selectedFilter, setSelectedFilter] = useState<any>({});
  const [showFilter, setShowFilter] = useState<boolean>(true);
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const dispatch = useAppDispatch();
  const [selectedClaim, setSelectedClaim] =
    useState<ClaimSearchDataType | null>(null);
  const claimSearchData: ClaimSearchDataType[] =
    useAppSelector(claimSearchSelector)?.claimsData?.result || [];
  const pagination = useAppSelector(claimSearchSelector)?.claimsData.pagination;

  const applyFilters = (claimFilter: ClaimSearchFilterType) => {
    setCurrentPage(1);
    setSelectedFilter(claimFilter);
  };

  const getClaimsList = () => {
    try {
      dispatch(
        ClaimsDataList(
          getClaimsRequest({
            selectedFilter,
            currentPage,
            pageSize,
          })
        )
      )
        .unwrap()
        .then((response) => {
          if (!isModalOpen) {
            setShowLoader(false);
          }

          if (!response?.result || response.result.length === 0) {
            toast('Data not found');
          }
        });
      setShowLoader(true);
    } catch (err) {
      toast.error('Failed to fetch claims');
    }
  };

  useEffect(() => {
    getClaimsList();
  }, [selectedFilter, currentPage, pageSize]);

  useEffect(() => {
    if (claimSearchData && claimSearchData.length > 0 && !isModalOpen) {
      setShowLoader(false);
    }
  }, [claimSearchData]);

  const toggleModal = () => {
    if (isModalOpen) {
      setSelectedClaim(null);
      setTimeout(() => {
        setInitModal(!initModal);
      }, 500);
    } else {
      setInitModal(!initModal);
    }
    setIsModalOpen(!isModalOpen);
  };

  const handleToggleSwitch = () => {
    setShowFilter((prev) => !prev);
  };

  return (
    <div>
      <Label className="text-heading">Claim Search</Label>
      <ToggleSwitch isOpen={showFilter} onClick={handleToggleSwitch} />

      <div className="task-item-parent-view">
        {showFilter && <ClaimSearchFilter onApplyFilters={applyFilters} />}
        <div className="mt-4">
          <KTable
            data={claimSearchData}
            tableParentClass={classNames('table-parent-assign-grid', {
              hideFilters: !showFilter,
            })}
            columnHeader={ClaimSearchColumnHeader}
            isLoading={showLoader}
            onAction={(param: any) => {
              setSelectedClaim(param);
              toggleModal();
            }}
          />

          {claimSearchData && claimSearchData.length > 0 && (
            <KPagination
              currentPage={pagination.currentPage}
              pageSize={pagination.pageSize}
              onPageChange={setCurrentPage}
              onSizeChange={setPageSize}
              fromItem={pagination.fromItem}
              toItem={pagination.toItem}
              totalItems={pagination.totalItems}
              // totalPages={0}
              hideHundredOption={true}
            />
          )}
        </div>
      </div>

      {initModal && (
        <ClaimSearchModal
          isOpen={isModalOpen}
          toggle={toggleModal}
          selectedClaim={selectedClaim}
        />
      )}

      {!isModalOpen && (
        <CenterSpinner showLoader={showLoader} className="spinner-60" />
      )}
    </div>
  );
};

export default ClaimSearchPage;
